import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClosuresService from "../../services/ClosuresService";
import { Clear, Replace } from "../../stores/closures/actions";

//Hooks
import useUser from "../user/useUser";
import useQueryString from '../queryString/useQueryString';

const MapClosures = (values) =>
    values?.map(closure => ({
        ...closure,
        cashRegisterName: closure?.cashRegister?.name,
        diff: closure?.arching?.diff
    }))

const useClosures = () => {
    const { branch } = useUser();
    const { closures, filters: initializer, pageSize, pageNumber, totalPage } = useSelector(state => state.closures_data);
    const { filters, setParameterSearch, search, clearFilters, GetQueryString } = useQueryString({ ...initializer, pageSize, pageNumber });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => dispatch(Clear())
    }, [dispatch])

    useEffect(() => {
        const SearchClosures = async () => {
            setLoading(true);
            await ClosuresService
                .SearchClosures(GetQueryString(), branch?.id)
                .then(res =>
                    dispatch(Replace(MapClosures(res.values), res.totalResults, res.totalPage)))
                .finally(() => setLoading(false));
        }
        if ((search && search !== '') && (branch && branch?.id && branch?.id !== 0))
            SearchClosures();
    }, [dispatch, search, branch, GetQueryString])

    return {
        closures,
        loading,
        totalPage,
        filters,
        search,
        clearFilters,
        setParameterSearch
    }
}
export default useClosures;